import { interval } from "rxjs";

export function requestAnimationFrame(frameRequestRate = 24) {
  return interval(1000 / frameRequestRate);
}
